import { ViewModel, View, ObservableArray } from "binder"
import { ToolModelFromProducerManipulationView } from "./toolModelFromProducerManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { ToolModelFromProducerEditorViewModel, ToolModelFromProducerInserter, ToolModelFromProducerUpdater } from "./toolModelFromProducerEditor/toolModelFromProducerEditor-viewModel";
import { IToolModelFromProducer } from "./IToolModelFromProducer";

export class ToolModelFromProducerManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف سازنده مدل ابزار';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.toolModelFromProducers = ObservableArray.create<ToolModelFromProducer>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new ToolModelFromProducerManipulationView();
    }
    public getTypeId(): string {
        return "VM-ED99904A-412A-4CAC-970A-BC09DBAE1F76"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolModelFromProducers(v: ObservableArray<ToolModelFromProducer>) { this._toolModelFromProducers = v; } public get toolModelFromProducers(): ObservableArray<ToolModelFromProducer> { return this._toolModelFromProducers; } private _toolModelFromProducers: ObservableArray<ToolModelFromProducer>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ToolModelFromProducerServices/ListAllToolModelFromProducers', {
                FilteringInformation: filteringInformation
            });
            this.toolModelFromProducers.update(...result.ToolModelFromProducers.map((x, i) => {
                let t = new ToolModelFromProducer(this);
                t.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                t.id = x.Id;
                t.toolModelId = x.ToolModelId;
                t.toolModelName = x.ToolModelName;
                t.toolModelCode = x.ToolModelCode;
                t.toolProducerId = x.ToolProducerId;
                t.toolProducerName = x.ToolProducerName;
                t.toolProducerCode = x.ToolProducerCode;
                return t;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new ToolModelFromProducerEditorViewModel(this, new ToolModelFromProducerInserter());
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(toolModelFromProducer: IToolModelFromProducer) {
        let popup = new ToolModelFromProducerEditorViewModel(this, new ToolModelFromProducerUpdater());
        await toolModelFromProducer.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async remove(toolModelFromProducer: ToolModelFromProducer): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                let result = await ServerConnection.callServer("/Complex/ToolModelFromProducerServices/DeleteToolModelFromProducer", {
                    ToolModelFromProducerId: toolModelFromProducer.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class ToolModelFromProducer extends ViewModel implements IToolModelFromProducer {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ToolModelFromProducerManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: ToolModelFromProducerManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set toolTypeId(v: string) { this._toolTypeId = v; } public get toolTypeId(): string { return this._toolTypeId; } private _toolTypeId: string;
    public set toolTypeName(v: string) { this._toolTypeName = v; } public get toolTypeName(): string { return this._toolTypeName; } private _toolTypeName: string;
    public set toolTypeCode(v: string) { this._toolTypeCode = v; } public get toolTypeCode(): string { return this._toolTypeCode; } private _toolTypeCode: string;
    public set toolModelId(v: string) { this._toolModelId = v; } public get toolModelId(): string { return this._toolModelId; } private _toolModelId: string;
    public set toolModelName(v: string) { this._toolModelName = v; } public get toolModelName(): string { return this._toolModelName; } private _toolModelName: string;
    public set toolModelCode(v: string) { this._toolModelCode = v; } public get toolModelCode(): string { return this._toolModelCode; } private _toolModelCode: string;
    public set toolProducerId(v: string) { this._toolProducerId = v; } public get toolProducerId(): string { return this._toolProducerId; } private _toolProducerId: string;
    public set toolProducerName(v: string) { this._toolProducerName = v; } public get toolProducerName(): string { return this._toolProducerName; } private _toolProducerName: string;
    public set toolProducerCode(v: string) { this._toolProducerCode = v; } public get toolProducerCode(): string { return this._toolProducerCode; } private _toolProducerCode: string;

    setToolModelId(id: string) {
        this.toolModelId = id;
    }
    getToolModelId(): string {
        return this.toolModelId;
    }

    setToolProducerId(id: string) {
        this.toolProducerId = id;
    }
    getToolProducerId(): string {
        return this.toolProducerId;
    }

    async cloneTo(toolModelFromProducer: IToolModelFromProducer) {
        toolModelFromProducer.id = this.id;
        toolModelFromProducer.setToolModelId(this.toolModelId);
        toolModelFromProducer.setToolProducerId(this.toolProducerId);
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }
}
